import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_basic_info_container';

let ids = {
  INPUT_EMAIL: 'INPUT_EMAIL',
  INPUT_EMAIL_CONFIRMATION: 'INPUT_EMAIL_CONFIRMATION',
  INPUT_WEBSITE: 'INPUT_WEBSITE',
  INPUT_COUNTRY: 'INPUT_COUNTRY',
  BTN_CONTINUE: 'BTN_CONTINUE',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_BASIC_INFO_CONTAINER_IDS = ids;
export const notABusinessLink = 'https://www.klarna.com/us/';
